export const resetResources = () => ({
  type: `RESET_RESOURCES`
});
